var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as PropTypes from 'prop-types';
/**
 * @hidden
 */
var PDFMargin = /** @class */ (function (_super) {
    __extends(PDFMargin, _super);
    function PDFMargin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFMargin.prototype.render = function () {
        return null;
    };
    PDFMargin.propTypes = {
        left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    };
    return PDFMargin;
}(React.Component));
export { PDFMargin };
//# sourceMappingURL=PDFMargin.js.map